export function getLicenseOld() {
    return 'cf60e93f84b10daf2131a12c0554dad4T1JERVI6MzU5NTEsRVhQSVJZPTE2NzM3ODUzNzgwMDAsS0VZVkVSU0lPTj0x'
}

export function getLicense() {
    return '09c4c6ac56cb3f1bd2f3daea35cde4bcTz01NDIxOCxFPTE2OTk3OTM2NjYwMzAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y'
}


